import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { getRedemptionHistorySelector } from '@patrianna-payments/shared-store/redeem/store/selectors'
import format from 'date-fns/format'

import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter'
import ProviderName from 'pageContainers/TransactionsPage/components/ProviderName'
import TransactionItem from 'pageContainers/TransactionsPage/components/TransactionItem'
import redeemFlowContent from 'prismic-translates/redeem-flow-content.json'
import content from 'prismic-translates/transactions-history-page.json'
import TransactionStatus from 'src/pageContainers/TransactionsPage/components/RedemptionTab/components/TransactionStatus'
import { useAppSelector } from 'store/hooks'
import type { RedeemItem } from 'temp/payment/client'

const t = getTranslationFromJson([content, redeemFlowContent])

const getDate = (date: string) =>
  date ? `${t('date_submitted')} ${format(new Date(date), `dd MMMM, yyyy '${t('at_word')}' hh:mm a`)}` : ''

export default function TransactionItems() {
  const { redeems = [] } = useAppSelector(getRedemptionHistorySelector)

  const { currencyFormatterWithGameCurrency } = useCurrencyFormatter()

  if (redeems) {
    return redeems.map(
      ({ id, provider, amount, currency, paymentDetails = '', createdAt, redeemStatus, status }: RedeemItem) => (
        <TransactionItem
          key={id}
          title={<ProviderName provider={provider} />}
          amount={currencyFormatterWithGameCurrency({ amount, currency })}
          date={getDate(createdAt)}
          transactionName={paymentDetails && `${t('method')}: ${paymentDetails}`}
          transactionId={`${t('transaction_id')}: ${id}`}
          status={<TransactionStatus id={id} status={status} redeemStatus={redeemStatus} />}
        />
      ),
    )
  }

  return null
}
